import React, { useState, useEffect } from "react";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  fade_bounce_delay_variants,
  bounce_right_to_left_variants
} from "shared/components/animations";
import scoreButton from "assets/images/vb/score-button.png";

const VBResultTurn = ({ role, joke, isResultRound, onUpdateStatus }) => {
  const [counter, setCounter] = useState(10);

  useEffect(() => {
    let timer;
    timer =
      role === "quarterback" &&
      counter > 0 &&
      setInterval(() => setCounter((prev) => prev - 1), 1000);
    counter === 0 && onUpdateStatus("update");
    return () => clearInterval(timer);
  }, [role, counter]);

  const getTeamColor = () => {
    if (isResultRound) {
      if (role === "deputy") {
        return "";
      } else {
        return "deputy";
      }
    } else {
      return role;
    }
  };

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="vb-result-turn"
    >
      <motion.div
        variants={bounce_right_to_left_variants}
        className={`vb-card-div result ${getTeamColor()}`}
      >
        <h2 className={`vb-primary-text result ${getTeamColor()}`}>
          {!isResultRound ? "Team A's turn is over!" : "This round has ended!"}
        </h2>
      </motion.div>
      {role === "quarterback" ? (
        <>
          <motion.div
            variants={fade_bounce_delay_variants}
            className="ok-btn-div"
            onClick={() => onUpdateStatus("update")}
          >
            <img alt="" src={scoreButton} className="" />
            <span className="ok-counter">{`(${counter})`}</span>
          </motion.div>
          <motion.h2
            variants={fade_bounce_delay_variants}
            className="next-round-text"
          >
            OK
          </motion.h2>
        </>
      ) : (
        <>
          <motion.h2
            variants={fade_bounce_delay_variants}
            className="joke-label"
          >
            Did you know?
          </motion.h2>
          <motion.p variants={fade_bounce_delay_variants} className="joke-text">
            {joke !== ""
              ? joke
              : `"Patience is not an ability to wait, but the ability to keep a good
            attitude while waiting." -Annoying Person`}
          </motion.p>
        </>
      )}
    </motion.div>
  );
};

export default VBResultTurn;
